import React from "react"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { resetStateAC } from "../../store/actions/builderActions"
import { Centered } from "../common/centered/Centered"
import { CustomH2 } from "../common/customH2/CustomH2"
import { AppLink } from "../common/link/AppLink"

export const Start = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    
    const handleClick = () => {
        dispatch(resetStateAC())
        navigate('/builder/credits')    
    }

    return <Centered>
        <div>
            <CustomH2>Construct your song</CustomH2>
            <AppLink action={handleClick}>Start</AppLink>
        </div>
    </Centered>
}